// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"OP","error":"PP","disabled":"QP"};